//import Icons here
import save from '../assets/icons/Iconly.png'
import download from '../assets/icons/Download.png'
import cut from '../assets/icons/cut.svg'

const Icons = { save, download, cut }

export default Icons
